/**
 * Abre uma URL externa (ex.: checkout da VIO Pay) em nova aba, sem vínculo com
 * a aba de origem (`noopener,noreferrer`): a plataforma segue aberta e a página
 * aberta não consegue manipular a aba que a abriu.
 *
 * Deve ser chamada dentro do handler de clique do usuário — fora dele o
 * navegador trata a abertura como pop-up e pode bloqueá-la.
 */
export function openInNewTab(url: string): void {
  if (!url.trim()) {
    throw new Error('openInNewTab: URL obrigatória');
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
